var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavHomeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 11H2.75L11 2.75L19.25 11H17.4167",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58337 11V17.4167C4.58337 17.9029 4.77653 18.3692 5.12034 18.713C5.46416 19.0568 5.93048 19.25 6.41671 19.25H15.5834C16.0696 19.25 16.5359 19.0568 16.8797 18.713C17.2236 18.3692 17.4167 17.9029 17.4167 17.4167V11",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.25V13.75C8.25 13.2638 8.44315 12.7975 8.78697 12.4537C9.13079 12.1098 9.5971 11.9167 10.0833 11.9167H11.9167C12.4029 11.9167 12.8692 12.1098 13.213 12.4537C13.5568 12.7975 13.75 13.2638 13.75 13.75V19.25",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavHomeWhite);
export default __webpack_public_path__ + "static/media/Icon_NavHome_White.78b59b2f40d753b34c409c3c12254857.svg";
export { ForwardRef as ReactComponent };